import { ChevronDown } from "lucide-react";
import { useState } from "react";
import { useLang } from "@/context/LanguageContext";
import { SourceBadge } from "@/components/SourceBadge";

const CASES = [
  { key: "base", label: "Base case", color: "#3B82F6" },
  { key: "bull", label: "Bull case", color: "#10B981" },
  { key: "bear", label: "Bear case", color: "#EF4444" },
];

function Case({ cfg, item, defaultOpen }) {
  const [open, setOpen] = useState(defaultOpen);
  const prob = item?.probability != null ? Math.round(item.probability) : null;
  return (
    <div className="border-b border-[#222733] py-3 last:border-0" data-testid={`macro-scenario-${cfg.key}`}>
      <button onClick={() => setOpen((o) => !o)} className="flex w-full items-center gap-2 text-left">
        <span className="text-[11px] font-bold uppercase tracking-wider" style={{ color: cfg.color }}>{cfg.label}</span>
        <span className="flex-1 truncate text-sm font-semibold text-slate-100">{item?.title || "—"}</span>
        {prob != null && <span className="font-mono text-sm font-bold" style={{ color: cfg.color }}>{prob}%</span>}
        <ChevronDown className={`h-4 w-4 shrink-0 text-slate-500 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && item?.description && (
        <p className="mt-2 text-sm leading-relaxed text-slate-400">{item.description}</p>
      )}
      {prob != null && (
        <div className="mt-2.5 h-2 w-full overflow-hidden rounded-full bg-[#161A22]">
          <div className="h-full rounded-full transition-all" style={{ width: `${prob}%`, background: cfg.color }} />
        </div>
      )}
    </div>
  );
}

export function MacroScenarios({ status, scenarios, source }) {
  const { t } = useLang();
  return (
    <div className="rounded-lg border border-[#222733] bg-[#0E1118] p-4 sm:p-5" data-testid="macro-scenarios">
      <div className="mb-3 flex items-center justify-between">
        <h3 className="font-heading text-xs font-bold uppercase tracking-wider text-slate-400">{t("c.scenarioTitle")}</h3>
        <SourceBadge source={source === "ai" ? "fallback" : source} />
      </div>
      {status === "loading" || status === "generating" ? (
        <div className="space-y-3">{[...Array(3)].map((_, i) => <div key={i} className="h-16 animate-pulse rounded bg-slate-800/40" />)}</div>
      ) : !scenarios ? (
        <p className="text-sm text-slate-500">{t("c.scenariosNone")}</p>
      ) : (
        CASES.map((cfg, i) => <Case key={cfg.key} cfg={cfg} item={scenarios[cfg.key]} defaultOpen={i === 0} />)
      )}
    </div>
  );
}
